import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeamListComponent } from './components/team-list/team-list.component';
import { HocModule } from '@hoc/hoc.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxTranslateModule } from '../translate/translate.module';
import { RouterLink } from '@angular/router';
import { CoreModule } from '@core/core.module';
import { EbcontGalaxyModule } from '@ebcont/ebcont.galaxy.js';
import { EmployeeDetailsComponent } from './components/employee-details/employee-details.component';
import { EmployeeDetailsPlaceholderComponent } from '@modules/team/components/employee-details/employee-details-placeholder/employee-details-placeholder.component';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { GeneralModule } from '@modules/general/general.module';
import { EmployeeToItemPipe } from './employee-to-item.pipe';
import { EmployeeProfileComponent } from './components/employee-details/employee-profile/employee-profile.component';
import { EmployeeSkillsComponent } from './components/employee-details/employee-skills/employee-skills.component';
import { EmployeeProjectsComponent } from './components/employee-details/employee-projects/employee-projects.component';
import { DetailsEmployeeListComponent } from './components/details-employee-list/details-employee-list.component';

@NgModule({
  declarations: [
    TeamListComponent,
    EmployeeDetailsComponent,
    EmployeeDetailsPlaceholderComponent,
    EmployeeToItemPipe,
    EmployeeProfileComponent,
    EmployeeSkillsComponent,
    EmployeeProjectsComponent,
    DetailsEmployeeListComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [TeamListComponent, DetailsEmployeeListComponent, EmployeeDetailsComponent],
  imports: [
    CommonModule,
    NgxTranslateModule,
    RouterLink,
    EbcontGalaxyModule,
    HocModule,
    CoreModule,
    FontAwesomeModule,
    GeneralModule
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class TeamModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far);
  }
}
